import Class from '@/Class';
import type View from '@/Views/View';

export default class ViewTuple extends Class {

    public view: JQuery<HTMLElement>;

    constructor(view: View, $view: JQuery) {
        super();
        this.view = $view;
        this.isDisposable = true;
    }
}